import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const Footer = () => {
  const { settings } = useSettings();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-[var(--aq-border)] bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-2xl tracking-[0.18em] mb-4">
            AQ <span className="text-[var(--aq-gold)]">·</span> Watches
          </div>
          <p className="text-sm text-[var(--aq-muted)] max-w-md leading-relaxed">
            Un atelier de relojería personalizada. Creamos piezas hechas a mano,
            diseñadas alrededor de tu estilo — silenciosamente precisas, inconfundiblemente tuyas.
          </p>
        </div>

        <div>
          <div className="overline mb-5">Navegar</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-black text-[var(--aq-muted)]">Inicio</Link></li>
            <li><Link to="/catalog" className="hover:text-black text-[var(--aq-muted)]">Catálogo</Link></li>
            <li><Link to="/custom-watches" className="hover:text-black text-[var(--aq-muted)]">Relojes Personalizados</Link></li>
            <li><Link to="/contact" className="hover:text-black text-[var(--aq-muted)]">Contacto</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Conecta</div>
          <ul className="space-y-3 text-sm">
            {settings?.instagram_url && (
              <li>
                <a
                  data-testid="footer-instagram"
                  href={settings.instagram_url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-[var(--aq-muted)] hover:text-black"
                >
                  <Instagram size={15} /> {settings.instagram_handle || "Instagram"}
                </a>
              </li>
            )}
            {settings?.whatsapp_number && (
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={`https://wa.me/${settings.whatsapp_number.replace(/[^\d]/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-[var(--aq-muted)] hover:text-black"
                >
                  <MessageCircle size={15} /> WhatsApp
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--aq-border)]">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[var(--aq-muted)] tracking-wider">© {year} AQ Watches. Todos los derechos reservados.</p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[var(--aq-muted)]">Atelier de relojería · Hecho a la medida</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
